import idb from '~/app/idb'
import registry from '~/app/registry'
import registryDB from '@/app/registry'

export default {
  SEX_MALE: 'male',
  SEX_FEMALE: 'female',
  levelName (value, lowerCase = false) {
    const n = lowerCase ? 'уровень' : 'Уровень'
    let v = {
      1: n + ' I',
      2: n + ' II',
      3: n + ' III',
      4: n + ' IV',
      5: n + ' V (самостоятельное питание)',
      6: n + ' V (питание через зонд/стому)'
    }
    return v[value] || ''
  },
  getActive () {
    return idb.get(idb.REGISTRY, registry.ACTIVE).then(registryItem => {
      if (registryItem) {
        return idb.get(idb.PROFILES, registryItem.value)
      }
      return Promise.resolve(null)
    })
  },
  getMaxId () {
    return this.getItems().then(items => {
      let maxId = 0
      for (let i in items) {
        if (items[i].id > maxId) {
          maxId = items[i].id
        }
      }
      return maxId
    })
  },
  getItems () {
    return idb.get(idb.PROFILES, (store) => {
      return store.getAll()
    })
  },
  save (obj = {
    name: '',
    birthdate: '',
    sex: 'male',
    disability: 1
  }) {
    return idb.save(idb.PROFILES, obj, !obj.id)
  },
  remove (profileId) {
    return idb.remove(idb.PROFILES, profileId).then(() => {
      return idb.open().then(db => {
        let transaction = db.transaction(idb.MEASURES, 'readwrite')
        let measureStore = transaction.objectStore(idb.MEASURES)
        return new Promise((resolve, reject) => {
          let profileIndex = measureStore.index(idb.INDEX_MEASURE_PROFILE)
          let cursorMeasure = profileIndex.openKeyCursor(IDBKeyRange.only(profileId))
          let promises = []
          cursorMeasure.onsuccess = function () {
            let cursor = cursorMeasure.result
            if (cursor) {
              promises.push(measureStore.delete(cursor.primaryKey))
              cursor.continue()
            } else {
              Promise.all(promises).then(() => {
                // Если удаляемый профиль активен, то сбрасываем флаг акативности
                registryDB.get(registryDB.ACTIVE).then((activeProfileId) => {
                  if (activeProfileId === profileId) {
                    registryDB.set(registryDB.ACTIVE, 0).then(() => {
                      resolve()
                    })
                  } else {
                    resolve()
                  }
                })
              }).catch(reject)
            }
          }
        })
      })
    })
  },
  getAll () {
    return idb.getAll(idb.PROFILES)
  }
}
